import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Camera, CameraOff } from 'lucide-react';

const ScannerCard = ({ scannerActive, startScanner, stopScanner, fileInputRef, handleFileScan, scannerContainerId }) => {
  return (
    <Card className="border-emerald-200">
      <CardContent className="p-3">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="flex items-center gap-1.5 text-xs text-emerald-600 font-medium">
            <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
            Wireless Scanner Ready — scan any barcode
          </span>
          <div className="h-4 w-px bg-gray-300" />
          {scannerActive ? (
            <Button variant="destructive" size="sm" onClick={stopScanner} className="h-7 gap-1.5 text-xs" data-testid="se-scanner-toggle">
              <CameraOff className="w-3 h-3" /> Stop Camera
            </Button>
          ) : (
            <Button variant="ghost" size="sm" onClick={startScanner} className="h-7 gap-1.5 text-xs text-gray-500" data-testid="se-scanner-toggle">
              <Camera className="w-3 h-3" /> Live Camera
            </Button>
          )}
          <Button variant="ghost" size="sm" className="h-7 gap-1.5 text-xs text-gray-500" onClick={() => fileInputRef.current?.click()} data-testid="se-camera-scan-btn">
            <Camera className="w-3 h-3" /> Camera Photo
          </Button>
          <input ref={fileInputRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={handleFileScan} data-testid="se-camera-file-input" />
        </div>
        <div className={`mt-3 flex justify-center ${!scannerActive ? 'hidden' : ''}`}>
          <div id={scannerContainerId} className="w-full max-w-sm rounded-lg overflow-hidden border border-emerald-200" data-testid="se-scanner-view" />
        </div>
        <div id="se-file-scanner-tmp" className="hidden" />
      </CardContent>
    </Card>
  );
};

export default ScannerCard;
